import moment from 'moment';
import 'moment/locale/ko';
import React, { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import HotelAllLogModal from '../../../../components/modal/hotelTabletAllLogModal';
import HotelTabletLogModal from '../../../../components/modal/hotelTabletLogModal';
import DetectorController, {
  AreaType,
  DeviceDetailType,
  DevicePathLogType,
  DeviceType,
  HotelListType,
  RoomType,
} from '../../../../controller/DetectorController';
import { AuthContext } from '../../../../navigation/TemporaryUserInfo';
import HotelDeviceSummary from '../../HotelDeviceSummary';
import { Style } from './style';
import TotalDevice from '../totalDevice';

const HotelDevice = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const nowDate = new Date();
  nowDate.setHours(0, 0, 0, 0);
  const [hotelList, setHotelList] = useState<HotelListType[]>([]);
  const [selectedHotel, setSelectedHotel] = useState<HotelListType | null>(null);
  const [areaList, setAreaList] = useState<AreaType[]>([]);
  const [deviceList, setDeviceList] = useState<DeviceType[]>([]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [allModalOpen, setAllModalOpen] = useState<boolean>(false);
  const [deviceDetailData, setDeviceDetailData] = useState<DeviceDetailType>();
  const [pathLogData, setPathLogData] = useState<DevicePathLogType[]>([]);
  const [userTokenId, setUserTokenId] = useState<any>();
  const [rotationDegree, setRotationDegree] = useState<number>(0);
  const [roomName, setRoomName] = useState<string>('');
  const today = new Date();
  const twoDaysAgo = new Date(today);
  twoDaysAgo.setHours(today.getHours() - 48);

  const getPowerBoxStatus = (subItem: DeviceType) => {
    // 전원이 상시인데 충전ON
    if (subItem.device_power === 1 && subItem.device_is_charging === 1) return 'on';
    // 전원이 상시인데 충전OFF
    if (subItem.device_power === 1 && subItem.device_is_charging === 0) return 'error';
    // 전원이 비상시인데 전원ON
    if (subItem.device_power === 0 && subItem.device_is_charging === 1) return 'on';
    // 전원이 비상시 이고 와이파이가 비상시인데 와이파이ON 이고 충전OFF
    if (
      subItem.device_power === 0 &&
      subItem.device_wifi_power === 0 &&
      subItem.loggedin_at > subItem.loggedout_at &&
      subItem.device_is_charging === 0
    )
      return 'error';
    return 'off';
  };
  const getWifiBoxStatus = (subItem: DeviceType) => {
    // 와이파이ON
    if (subItem.loggedin_at > subItem.loggedout_at) return 'on';
    if (subItem.loggedin_at !== null && subItem.loggedout_at === null) return 'on';
    // 와이파이가 상시이고 전원이 상시인데 와이파이OFF
    if (
      subItem.device_wifi_power === 1 &&
      subItem.device_power === 1 &&
      subItem.loggedin_at < subItem.loggedout_at
    )
      return 'error';
    // 수정필요
    // 와이파이가 상시이고 전원이 비상시인데 전원ON 이고 와이파이OFF
    // if (
    //   subItem.device_wifi_power === 1 &&
    //   subItem.device_power === 0 &&
    //   subItem.device_is_charging === 1 &&
    //   subItem.loggedin_at < subItem.loggedout_at
    // )
    //   return 'error';

    return 'off';
  };
  const getAppErrorStatus = (subItem: DeviceType) => {
    // 와이파이ON 이고 device_app_state BACKGROUND
    if (subItem.loggedin_at > subItem.loggedout_at && subItem.device_app_state === 'background')
      return 'error';
  };

  // 당일 매출건수의 페이지 개수
  const [pageCount, setPageCount] = useState<number>(1);

  // API 호출
  const getHotelList = async () => {
    try {
      const response = await DetectorController.getHotelList();

      if (response && response.data.ok) {
        const formattedHotelList = response.data.data?.map((item: any) => ({
          value: item.store_name,
          label: item.store_name,
          store_id: item.store_id,
          user_id: item.user_id,
        }));
        setHotelList(formattedHotelList);
        setSelectedHotel(formattedHotelList[0] || null);
      } else {
        if (response.data.msg === 'VERIFY_ERROR') {
          logout();
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getHotelDevice = async () => {
    try {
      const oData = {
        store_id: selectedHotel?.store_id,
        user_id: selectedHotel?.user_id,
      };

      const response = await DetectorController.getHotelDevice(oData);
      if (response && response.data.ok) {
        setAreaList(response.data.data);
        setDeviceList(
          response.data.data.flatMap((item: AreaType) =>
            item.room.flatMap((data) => data.device_list),
          ),
        );
      } else {
        if (response.data.msg === 'VERIFY_ERROR') {
          logout();
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getData = async (user_token_id: number, start_date: Date, end_date: Date) => {
    try {
      const oData = {
        limit: 200,
        start_date: moment(start_date).format('YYYY-MM-DD'),
        end_date: moment(end_date).format('YYYY-MM-DD'),
        user_token_id: user_token_id,
      };

      const response = await DetectorController.getHotelDevicePathlog(oData);

      if (response && response.data) {
        setPathLogData(response.data.data);

        setModalOpen(true);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const getAllData = async (start_date: Date, end_date: Date, offset: number) => {
    try {
      const oData = {
        store_id: selectedHotel?.store_id,
        start_date: moment(start_date).format('YYYY-MM-DD'),
        end_date: moment(end_date).format('YYYY-MM-DD'),
        limit: 10,
        offset: offset,
      };

      const response = await DetectorController.getHotelAllPathlog(oData);

      if (response && response.data) {
        setAllModalOpen(true);
        setPathLogData(response.data.data.log);
        setPageCount(Math.ceil(response.data.data.total_count / 10));
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const getUserTokenInfo = async (user_token_id: number) => {
    try {
      const oData = {
        user_token_id: user_token_id,
      };
      const response = await DetectorController.getUserTokenInfo(oData);

      if (response && response.data) {
        setDeviceDetailData(response.data.data);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const openPathLog = (
    user_token_id: number,
    start_date: Date,
    end_date: Date,
    offset?: number,
  ) => {
    setUserTokenId(user_token_id);
    if (user_token_id === -1 && offset !== undefined) {
      getAllData(start_date, end_date, offset);
    } else {
      getData(user_token_id, start_date, end_date);
      getUserTokenInfo(user_token_id);
    }
  };

  const handleRotateClick = () => {
    setRotationDegree((prevDegree) => prevDegree - 360);
    getHotelDevice();

    toast.success('기기상태를 새로고침했어요');
  };

  const renderDevices = (devices: DeviceType[], room: RoomType) => {
    if (devices.length > 0) {
      return devices.map((device) => {
        const isActive = device.device_app_state === 'active'; // 앱상태
        const isCharging = device.device_is_charging === 1; //충전 여부
        const isLoggedIn = device.loggedin_at > device.loggedout_at || !device.loggedout_at; //인터넷
        const isPower = device.device_power; //전원
        const isWifiPower = device.device_wifi_power; //와이파이
        const isLBattery = device.device_battery; //배터리
        const isVolume = device.device_volume; //볼륨
        const isLogged = device.logged_at; //마지막 로그
        // 수정필요
        // const isVacancy =
        //   device.device_wifi_power === 1 &&
        //   device.device_power === 0 &&
        //   device.device_is_charging === 1 &&
        //   device.loggedin_at < device.loggedout_at;

        const isNormal = device.normal === 1;
        const appVersion = device.app_version;

        return (
          <div
            className={`devicesWrap ${
              !isNormal ? 'error' : new Date(isLogged) < twoDaysAgo ? 'longTime' : ''
            }`}
            key={device.user_token_id}>
            <div className="rowCenter">
              <div className={`powerBox ${getPowerBoxStatus(device)}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_power_${getPowerBoxStatus(device)}.svg`}
                  alt="전원"
                  width={16}
                />
                <h4>{device.device_power === 0 ? '비상시' : '상시'}</h4>
              </div>

              <div className={`powerBox ${getWifiBoxStatus(device)}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_wifi_${getWifiBoxStatus(device)}.svg`}
                  alt="와이파이"
                  width={16}
                />
                <h4>{device.device_wifi_power === 0 ? '비상시' : '상시'}</h4>
              </div>

              {getAppErrorStatus(device) === 'error' && (
                <div className={`powerBox ${getAppErrorStatus(device)}`}>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_app_${getAppErrorStatus(device)}.svg`}
                    alt="앱"
                    width={14}
                  />
                  <h4>앱 이상</h4>
                </div>
              )}
            </div>
            <div className="devicesContent">
              <div className={`powerBox ${getPowerBoxStatus(device)}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/${
                    getPowerBoxStatus(device) === 'on'
                      ? 'ic_charge.svg'
                      : getPowerBoxStatus(device) === 'error'
                      ? 'ic_notCharge.svg'
                      : 'ic_success_charge.svg'
                  }`}
                  alt={isCharging ? '충전중' : isLBattery === 100 ? '충전완료' : '충전오류'}
                  width={14}
                />
                <h4>{isLBattery}%</h4>
              </div>
            </div>

            {getWifiBoxStatus(device) === 'error' && (
              <div className={`powerBox ${getWifiBoxStatus(device)}`}>
                <img
                  src={`${process.env.PUBLIC_URL}/svg/ic_wifi_error.svg`}
                  alt="와이파이"
                  width={16}
                />
                <div>
                  <h4>
                    {device.loggedout_at &&
                      moment(device.loggedout_at).format('YYYY/MM/DD HH:mm:ss')}
                  </h4>
                </div>
              </div>
            )}
            <div className="powerBox">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_volume.svg`} alt="볼륨" width={12} />
              <h4 style={{ color: '#777' }}>{isVolume ? isVolume : 0}%</h4>
            </div>

            <div className="bottomBoxWrap">
              <div className="devicesContent rowCenter">
                <h4
                  style={{
                    color: '#7a7a7a',
                  }}>
                  ID: {device.user_token_id} {appVersion !== '' && '/ V.' + appVersion}
                </h4>
              </div>
              {device.build_version && (
                <div className="devicesContent rowCenter">
                  <h4
                    style={{
                      color: '#7a7a7a',
                    }}>
                    빌드버전: {device.build_version}
                  </h4>
                </div>
              )}
              <div className="devicesContent rowCenter">
                <h4
                  style={{
                    color: '#7a7a7a',
                  }}>
                  최근 로그 {isLogged ? moment(isLogged).format('YYYY/MM/DD HH:mm:ss') : 'null'}
                </h4>
              </div>

              <button
                onClick={() => {
                  openPathLog(device.user_token_id, new Date(), new Date());
                  setRoomName(room.name);
                }}
                className="logViewButton">
                로그보기
              </button>
            </div>
          </div>
        );
      });
    } else {
      return (
        <div className="devicesWrap fail">
          <p>연결기기 없음</p>
        </div>
      );
    }
  };

  const renderRoom = (room: RoomType) => {
    return (
      <div className="roomContent" key={room.number}>
        <div className="roomTitle">
          <h2>{room.name}</h2>
          {room.device_list.map(
            (data) =>
              data.device_status !== 'abnormal' && (
                <div
                  key={data.area_number}
                  className={`roomTypeStatus ${data.device_status === 'checkin' && 'checkin'}`}>
                  {
                    {
                      alltime: '상시',
                      checkin: '입실',
                      checkout: '공실',
                    }[data.device_status]
                  }
                </div>
              ),
          )}
        </div>
        <div className="renderWrap">{renderDevices(room.device_list, room)}</div>
      </div>
    );
  };
  const renderArea = (area: AreaType) => {
    return (
      <div className="areaWrap" key={area.area_number}>
        <h2>{area.area_name}</h2>
        <div className="roomWrap">{area.room.map(renderRoom)}</div>
      </div>
    );
  };

  const handleChange = (selectedOption: HotelListType | null) => {
    setSelectedHotel(selectedOption);
  };

  useEffect(() => {
    getHotelList();
  }, []);

  useEffect(() => {
    if (selectedHotel) {
      getHotelDevice();
    }
  }, [selectedHotel]);

  return (
    <Style>
      <div className="wrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <h1>호텔 객실 기기 확인</h1>

        <TotalDevice />
        <div className="row">
          <Select
            options={hotelList}
            value={selectedHotel}
            onChange={handleChange}
            className="selectWrap"
          />
          <button
            className="rotateButton"
            onClick={() => {
              handleRotateClick();
            }}>
            <p>새로고침</p>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_refresh.svg`}
              alt="refresh"
              style={{
                transform: `rotate(${rotationDegree}deg)`,
                transition: 'transform 1s ease',
              }}
            />
          </button>
        </div>
        {selectedHotel && (
          <button
            onClick={() => {
              openPathLog(-1, new Date(), new Date(), 0);
            }}
            className="logViewButton marginTop total">
            전체 로그보기
          </button>
        )}
        <HotelDeviceSummary
          deviceList={deviceList}
          getPowerBoxStatus={getPowerBoxStatus}
          getWifiBoxStatus={getWifiBoxStatus}
          getAppErrorStatus={getAppErrorStatus}
        />
        <div className="borderLine"></div>
        <div className="deviceListWrap">{areaList && areaList.map(renderArea)}</div>
      </div>
      <HotelTabletLogModal
        isVisible={modalOpen}
        setVisible={setModalOpen}
        pathLogData={pathLogData}
        openPathLog={openPathLog}
        userTokenId={userTokenId}
        deviceDetailData={deviceDetailData}
        refresh={getHotelDevice}
        roomName={roomName}
      />
      <HotelAllLogModal
        isVisible={allModalOpen}
        setVisible={setAllModalOpen}
        pathLogData={pathLogData}
        openPathLog={openPathLog}
        pageCount={pageCount}
        setPageCount={setPageCount}
      />
    </Style>
  );
};

export default HotelDevice;
